import { PostData } from '../types';

export const creatorStoryManual = (data: PostData) =>
  data.publishingMethod === 'DIRECT' && data.profileType === 'creator' && data.feedType === 'story';
